// extracted by mini-css-extract-plugin
export default {"root":"_17zve","transform":"_1lIEk","swipeable":"_3NDrc","preview":"_1_DaN","next":"_39DIH","prev":"_3v6zn"};